<template>
    <div>
      <section class="invoice-preview-wrapper"> 
        <BRow v-if="expense" class="invoice-preview" >
      
          <!-- Col: Left (Expense Container) -->
          <BCol cols="12" xl="9" md="8">
            <BCard no-body class="invoice-preview-card">
              <!-- Header -->
              <BCardBody class="invoice-padding pb-0">
      
                <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
      
                  <!-- Header: Left Content -->
                  <div>
                    <div class="logo-wrapper">
                      <BImg :src="appLogoImage" width="50" />
                      <h3 class="text-primary invoice-logo"> {{ appName }} </h3>
                    </div>
                  </div>
      
                  <!-- Header: Right Content -->
                  <div class="mt-md-0 mt-2">
                    <h4 class="invoice-title"> <span class="invoice-number">{{expense.name}}</span> </h4>
                    <div class="invoice-date-wrapper">
                      <p class="invoice-date-title"> {{ $t('Emit Date') }}: </p>
                      <p class="invoice-date"> {{ formatDate(expense.emit_date) }} </p>
                    </div>
                    <div v-if="expense.payment_date" class="invoice-date-wrapper">
                      <p class="invoice-date-title"> {{ $t('Due Date') }}: </p>
                      <p class="invoice-date"> {{ expense.payment_date ? formatDate(expense.payment_date) : '' }} </p>
                    </div>
                  </div>
                </div>
              </BCardBody>
      
              <!-- Spacer -->
              <hr class="invoice-spacing">
      
              <!-- Expense Client & Payment Details -->
              <BCardBody v-if="expense" class="invoice-padding pt-0" >
                <BRow class="invoice-spacing">
      
                  <!-- Col: Expense To -->
                  <BCol cols="12" xl="6" class="p-0">
                    <h6 class="mb-2"> {{ $t('Invoice To') }}: </h6>
                    <h6 class="mb-25"> {{ expense.customer_billing_full_name }} </h6>

                  </BCol>
      
                  <!-- Col: Payment Details -->
                  <BCol xl="6" cols="12" class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end">
                    <div>
                      <h6 class="mb-2"> {{ $t('Payment Details') }}:</h6>
                      <table>
                        <tbody>
                          <tr v-if="expense.customer_billing_account">
                            <td class="pr-1"> {{ $t('Bank account') }}:</td>
                            <td>{{ expense.customer_billing_account }}</td>
                          </tr>
                          <tr>
                            <td class="pr-1">{{ $t('Name') }}:</td>
                            <td>{{ expense.customer_billing_full_name }}</td>
                          </tr>
                          <tr>
                            <td class="pr-1">{{ $t('NIF') }}:</td>
                            <td>{{ expense.customer_billing_nif }}</td>
                          </tr>
                          <tr>
                            <td class="pr-1">{{ $t('Address') }}:</td>
                            <td>{{ expense.customer_billing_address }}</td>
                          </tr>
                          <tr>
                            <td class="pr-1">{{ $t('City') }}:</td>
                            <td>{{ expense.customer_billing_city }}</td>
                          </tr>
                          <tr>
                            <td class="pr-1">{{ $t('Province') }}:</td>
                            <td>{{ expense.customer_billing_province }}</td>
                          </tr>
                          <tr v-if="expense.customer_billing_postal_code" >
                            <td class="pr-1">{{ $t('Postal code') }}:</td>
                            <td>{{ expense.customer_billing_postal_code }}</td>
                          </tr>
                          <tr>
                            <td class="pr-1"> {{ $t('Country') }}:</td>
                            <td>{{ expense.customer_billing_country }}</td>
                          </tr>
                          <tr>
                            <td class="pr-1"></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </BCol>
                </BRow>
              </BCardBody>
      
              <!-- Expense Description: Table -->
              <BTableLite responsive :items="expense.items" :fields="['item', 'cantidad', 'importe', 'descuento',  'iva','irpf', 'total']">
                <template #cell(item)="data">
                  <BCardText class="font-weight-bold mb-25"> {{ data.item.item }} </BCardText>
                  <BCardText class="text-nowrap text-muted"> <small>{{ data.item.observations }} </small></BCardText>
                </template>
                <template #cell(importe)="data">{{ data.item.quantity }}</template>
                <template #cell(cantidad)="data">{{ formatCurrency(data.item.amount) }}</template>
                <template #cell(descuento)="data"> {{ data.item.discount + "%" }} </template>
                <template #cell(iva)="data"> {{ data.item.vat + "%" }} </template>
                <template #cell(irpf)="data"> {{ data.item.pit? data.item.pit  + "%" : '0%' }} </template>
                <template #cell(total)="data"> {{ formatCurrency(data.item.total) }} </template>
              </BTableLite>
      
              <hr class="invoice-spacing">
      
              <!-- Expense Description: Total -->
              <BCardBody class="invoice-padding pb-0" style="margin-bottom:23.2px;">
                <BRow>
      
                  <!-- Col: Sales Persion -->
                  <BCol cols="12" md="6" class="mt-md-0 mt-3" order="2" order-md="1" >
                    <BCardText class="mb-0">
                      <span class="font-weight-bold">{{ $t('User') }}:</span>
                      <span class="ml-75">{{ expense.user_full_name }}</span>
                    </BCardText>
                  </BCol>
      
                  <!-- Col: Total -->
                  <BCol cols="12" md="6" class="mt-md-6 d-flex justify-content-end" order="1" order-md="2">
                    <div class="invoice-total-wrapper">
                      <div class="invoice-total-item">
                        <p class="invoice-total-title"> Subtotal: </p>
                        <p class="invoice-total-amount"> {{ formatCurrency(expense.subtotal) }} </p>
                      </div>

                      <div class="invoice-total-item">
                        <p class="invoice-total-title"> Descuentos </p>
                        <p class="invoice-total-amount"> {{ formatCurrency(expense.discounts) }} </p>
                      </div>

                      <div class="invoice-total-item">
                        <p class="invoice-total-title"> {{ $t('Base imponible') }}: </p>
                        <p class="invoice-total-amount"> {{ formatCurrency(expense.taxableBase) }} </p>
                      </div>
                      
                      <div class="invoice-total-item" v-for="v of expense.vats">
                        <p class="invoice-total-title"> IVA {{ v.value }}% </p>
                        <p class="invoice-total-amount"> {{formatCurrency(v.price)}} </p>
                      </div>
                      <div class="invoice-total-item" v-if="!(expense.pits.length==0)" v-for="p of expense.pits" >
                        <p class="invoice-total-title"> IRPF {{ p.value }}% </p>
                        <p class="invoice-total-amount"> {{formatCurrency(p.price)}} </p>
                      </div>
                      <hr class="my-50">
                      <div class="invoice-total-item">
                        <p class="invoice-total-title"> {{ $t('Total') }}: </p>
                        <p class="invoice-total-amount"> {{ formatCurrency(expense.amount) }} </p>
                      </div>
                    </div>
                  </BCol>
                </BRow>
              </BCardBody>
      
              <!-- Spacer -->
              <div v-if="expense.note" >
      
              <hr class="invoice-spacing">
      
              <!-- Note -->
              <BCardBody class="invoice-padding pt-0">
                <span class="font-weight-bold">Nota: </span>
                <span>{{ expense.note }}</span>
              </BCardBody>
            </div>
            </BCard>
          </BCol>
      
          <!-- Right Col: Card -->
          <BCol cols="12" md="4" xl="3" class="invoice-actions" >
            <BCard>
              
              <BButton v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="primary" class="mb-75" block :to="{ name: 'expenses-edit', params: { id: $route.params.id } }" > {{ $t('Edit') }} </BButton>
              <BButton variant="outline-danger" block @click="deletePopup(expense.id, 'expenses/deleteExpense', 'expenses')" v-if="ability.can('delete', 'expense')"> {{$t('Delete')}} </BButton>

              
                  
                 

            </BCard>
            <BCard>
              <BCardTitle v-if="expense.pdf_upload"><h5><b>{{ expense.pdf_upload }}</b></h5></BCardTitle>
              <BCardTitle v-else> <h5><b>Sube tu PDF</b></h5> </BCardTitle>
                  <div v-if="expense.pdf_upload" class="d-flex">
                      <div class="col-8 m-0 p-0 pr-2">
                        <BButton variant="outline-primary" class="mr-2"  block @click="showModal" > 
                          <div class="d-flex justify-content-center">
                            <span>Visualizar</span>
                          </div>
                        </BButton>
                      </div>
      
                      <div class="col-4 m-0 p-0">
                        <BButton variant="outline-danger" block @click="deleteFileUpload('pdf')" > 
                          <div class="d-flex justify-content-center">
                            <FeatherIcon size="16" icon="TrashIcon" /> 
                          </div>
                        </BButton>
                      </div>
                  </div>
                <div v-else >
                  <BFormFile class="col-12"  accept=".pdf" @change="(event) => onExpenseUpload('pdf', event)" placeholder="Elige un archivo..." drop-placeholder="Suéltalo aquí..." />
                  <small>{{ expense.pdf_upload }}</small>
                </div>

            </BCard>
            <BCard>
              <BCardTitle v-if="expense.face_upload"><h5><b>{{ expense.face_upload }}</b></h5></BCardTitle>
              <BCardTitle v-else> <h5><b>Sube tu FacturaE</b></h5> </BCardTitle>
                  <div v-if="expense.face_upload" class="d-flex">
                      <div class="col-8 m-0 p-0 pr-2">
                        <BButton variant="primary" class="mr-2"  block @click="exportData(`/get-expense-upload`, {id: expense.id, type: 'xsig'}, expense.name, 'XSIG')" > 
                          <div class="d-flex justify-content-center">
                            <span>Descargar</span>
                          </div>
                        </BButton>
                      </div>
                      <div class="col-4 m-0 p-0">
                        <BButton variant="outline-danger" block @click="deleteFileUpload(('xsig'))" > 
                          <div class="d-flex justify-content-center">
                            <FeatherIcon size="16" icon="TrashIcon" /> 
                          </div>
                        </BButton>
                      </div>
                  </div>
                <div v-else >
                  <BFormFile class="col-12"  accept=".xsig" @change="(event) => onExpenseUpload('xsig', event)" placeholder="Elige un archivo..." drop-placeholder="Suéltalo aquí..." />
                  <small>{{ expense.pdf_upload }}</small>
                </div>
           </BCard>

          </BCol>
        </BRow>
      
        <!-- <ExpenseSidebarSendExpense />
        <ExpenseSidebarAddPayment /> -->
      </section>
      
            <!-- Payment section -->
            <section v-if="expense">
          <BRow>
              <BCol cols="12" xl="9" md="8">
                  <BCard>
                      <BRow class="mb-2">
                          <BCol>
                              <h3>Pagos y devoluciones asociadas</h3>
                          </BCol>
                      </BRow>
                      <BRow>
                          <BCol v-if="expense.total_payment != expense.amount">
                              <BButton variant="outline-primary" @click="openPaymentModal">
                                  <FeatherIcon icon="PlusIcon" class="mr-50" />
                                  <span class="align-middle">Añadir</span>
                              </BButton>
                          </BCol>
                          <BCol cols="12" class="mt-2">
                            <BTable :items="expense.payments" show-empty empty-text="Ningún pago o  devolución asociada" :fields="paymentFields" v-if="expense">
                              <template #cell(amount)="data">
                                {{ formatCurrency(data.item.amount) }}
                              </template>
                              <template #cell(payment_date)="data">
                                {{ formatDate(data.item.payment_date) }}
                              </template>
                              <template #cell(actions)="data">
                                <BButton v-ripple.400="'rgba(40, 199, 111, 0.15)'" variant="flat-danger" class="btn-icon" @click="deletePopupAxios(data.item.id, `payments/${data.item.id}`)">
                                  <FeatherIcon size="18" icon="TrashIcon" />
                                </BButton>
                              </template>
                            </BTable>
                          </BCol>
                      </BRow>
                  </BCard>
              </BCol>
          </BRow>
          
          <!-- Payment modal -->
          <BModal hide-footer ref="paymentModal" cancel-variant="outline-secondary" centered title="Añadir pago o devolución" no-close-on-backdrop>
              <BForm @submit.prevent="addPayment">
                  <BCol class="mb-1">
                    <label for="payment_method">Método de pago</label>
                    <VueSelect id="payment_method" v-model="payment.payment_method_id" :options="paymentMethods" label="name" :reduce="payment => payment.id" required v-if="paymentMethods" />
                  </BCol>
                  <BCol v-if="cashes && showCashes">
                    <label >Caja</label>
                    <VueSelect v-model="payment.cash_id" :reduce="cash => cash.id" :options="cashes" label="name" id="payment-method" class="payment-selector" :clearable="false"/>
                  </BCol>

                  <DatepickerValidated vsName="Fecha de pago" :vsModel.sync="payment.payment_date" />

                  <BCol>
                    <BFormGroup label="Importe" label-for="payment_amount">
                      <BFormInput type="number" step="0.01" id="payment_amount" :max=" (expense.amount > 0) ?  parseFloat(expense.amount - expense.total_payments).toFixed(2) : 0" :min="(expense.amount > 0) ? 0 : parseFloat(expense.amount - expense.total_payments)" v-model="payment.amount" required />
                    </BFormGroup>
                    <p><small class="text-muted">RECUERDA: Los pagos son positivos y las devoluciones negativas.</small></p>
                  </BCol>
                  <BCol class="d-flex justify-content-end mt-2">
                      <BButton variant="danger" class="mr-1" @click="closePaymentModal">Cancelar</BButton>
                      <BButton variant="primary" type="submit">Añadir</BButton>
                  </BCol>
              </BForm>
          </BModal>
        </section>

        <BModal size="lg" hide-footer ref="pdfViewerModal">
          <iframe  id="iframe" width="100%" scrolling="auto" height="800px" 
            frameborder="1"
            style="border: 0rem none #ffffff;" name="national-campaign" 
            marginheight="0rem" marginwidth="0rem" >
          </iframe>
        </BModal>
    </div>
  </template>
  
<script>
import { BRow, BCol, BCard, BCardBody, BTableLite, BCardText, BButton, BAlert, BLink, VBToggle, BImg, BTable, BForm, BFormGroup, BFormInput, BFormFile, BCardTitle } from 'bootstrap-vue'
// import ExpenseSidebarSendExpense from '../ExpenseSidebarSendExpense.vue'
// import ExpenseSidebarAddPayment from '../ExpenseSidebarAddPayment.vue'
import { VueSelect } from 'vue-select'
import { ref, onUnmounted, computed, watch } from '@vue/composition-api'
import { $themeConfig } from '@themeConfig'
import Logo from '@core/layouts/components/Logo.vue'
import expensesModule from '../expensesModule'
import Ripple from 'vue-ripple-directive'
import router from '@/router'
import store from '@/store'
import axios from '@axios'
import dateUtils from '@/hooks/dateUtils'
import currency from '@/utils/currency'
import ability from '@/libs/acl/ability';
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue'
import { uploadExpense, getExpenseUpload, deleteExpenseUpload } from '@/composables/expenseService'
import popups from '@/hooks/popups';
import exportUtils from '@/hooks/exportUtils'

export default {
    components: { BRow, BCol, BCard, BCardBody, BTableLite, BCardText, BButton, BAlert, BLink, Logo, BImg, BTable, BForm, BFormGroup, BFormInput, VueSelect, DatepickerValidated, BFormFile, BCardTitle },
    directives: { Ripple,'b-toggle': VBToggle},
    setup() {
        const { exportData } = exportUtils()
        const { formatDate } = dateUtils()
        const { formatCurrency } = currency()
        const { appName, appLogoImage } = $themeConfig.app
        const { errorToast, successToast, deletePopupAxios, deletePopup } = popups()
        const INVOICE_MODULE = 'expenses'
        const paymentDetails = ref({})
        const expense = ref(null)
        const paymentModal = ref(null)
        const pdfViewerModal = ref(null)
        const paymentMethods = ref([])
        const cashes=ref(null)
        const showCashes=ref(false)
        const payment = ref({
          payment_method_id: null,
          amount: null,
          cash_id:null,
          payment_date: new Date(Date.now()).toISOString(),
        })

        const iframeKey = ref(0)
        const pdfUpload= ref(null)
        const paymentFields = ref([
          { key: 'payment_method.name', label: 'Método de pago' },
          { key: 'amount', label: 'Importe' },
          { key: 'payment_date', label: 'Fecha' },
          { key: 'actions', label: 'Acciones' },
        ])

        // Register module
        if (!store.hasModule(INVOICE_MODULE)) store.registerModule(INVOICE_MODULE, expensesModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(INVOICE_MODULE)) store.unregisterModule(INVOICE_MODULE)
        })


        const getPdfUpload = async function () {
          let response = await getExpenseUpload(expense.value.id)
          let blob = new Blob([response], { type: 'application/pdf' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = expense.value.name+'.pdf'
        
          if (response) {
            let iframe = document.getElementById("iframe"); 
            iframe.src=link.href
          }
        }

        const deleteFileUpload = async function (type) {
          let response = await deleteExpenseUpload({id: expense.value.id, type: type})
          if (response.success) {
            successToast(type.toUpperCase() + " borrado correctamente")
            fetchData()
          } else {
            errorToast("No se ha podido borrar el " + type.toUpperCase())
          }
        
        }

        const showModal= () => {
          pdfViewerModal.value.show()

          setTimeout(function() {
            getPdfUpload()
          }, 100);
        }

        const fetchData = function(){
          store.dispatch('expenses/fetchExpense', { id: router.currentRoute.params.id }).then(response => {
              expense.value = response.data.expense

              if (expense.value.pdf_upload) expense.value.pdf_upload = expense.value.pdf_upload.replace('expense\\', '');
              if (expense.value.face) expense.value.face = expense.value.face.replace('expense\\', ''); 

          })
        }

        fetchData()

      
        const onExpenseUpload = async function (type, event) {
          let file 
          if (event.target.files) {
            file = event.target.files[0]
          } else {
            file = event.dataTransfer.files[0]
          }

          let response = await uploadExpense(file, expense.value.id, type)
          if (response.success) {
            successToast(type.toUpperCase() + " subido correctamente")
            fetchData()
          } else {
            errorToast("Error subiendo " + type.toUpperCase())
          }
        }

        axios.get('/payment-methods').then(response =>{
            paymentMethods.value = response.data
        })

        axios.get('cashes').then(response => {
          cashes.value=response.data.cashes
        })

        /**
         * Abrir modal de pagos
         */
         const openPaymentModal = function(){
          payment.value.expense_id = router.currentRoute.params.id
          payment.value.amount = parseFloat(expense.value.amount).toFixed(2) - parseFloat(expense.value.total_payments).toFixed(2)
          payment.value.amount = parseFloat(payment.value.amount).toFixed(2)
          paymentModal.value.show()
        }

        /**
         * Cerrar modal de pagos
         */
        const closePaymentModal = function(){
          paymentModal.value.hide()
          payment.value = {
            payment_method_id: null,
            cash_id:null,
            amount: null,
            payment_date: new Date(Date.now()).toISOString(),
          }
        }

        /**
         * Añadir pago
         */
         const addPayment = function(){

          if(payment.value.amount==0){
            errorToast("El pago/devolución no puede ser 0")
                return
            }
            if(!payment.value.payment_method_id){
                errorToast("Select a payment method")
                return
            }

            if(payment.value.payment_method_id==1 && !payment.value.cash_id){
                errorToast("Select a cash")
                return
            }

            axios.post('payments', payment.value).then(response => {
                if (response.data.success) {
                  successToast('Payment created')
                  closePaymentModal()
                  fetchData()
                } else {
                  errorToast(response.data.msg)
                } 
            })
            .catch(error => {
                errorToast("Error on create payment")
            })
        }

        watch(payment, () => {
          if (payment.value.payment_method_id==1) {
          showCashes.value=true
        } else {
          showCashes.value=false
        }
        }, {deep:true})

        return {
            closePaymentModal,
            openPaymentModal,
            addPayment,
            fetchData,
            deletePopupAxios,
            paymentMethods,
            paymentDetails,
            paymentFields,
            paymentModal,
            appLogoImage,
            payment,
            expense,
            appName,
            cashes, 
            showCashes, 
            formatDate,
            formatCurrency,
            deletePopup,
            ability, 
            onExpenseUpload,
            pdfUpload,
            pdfViewerModal,
            showModal,
            iframeKey,
            deleteFileUpload,
            exportData
        }
    },
}
</script>
  
  <style lang="scss" scoped>
  @import "~@core/scss/base/pages/app-invoice.scss";
  </style>
  
  <style lang="scss">
  @media print {
  
    // Global Styles
    body {
      background-color: transparent !important;
    }
    nav.header-navbar {
      display: none;
    }
    .main-menu {
      display: none;
    }
    .header-navbar-shadow {
      display: none !important;
    }
    .content.app-content {
      margin-left: 0;
      padding-top: 32px !important;
    }
    footer.footer {
      display: none;
    }
    .card {
      background-color: transparent;
      box-shadow: none;
    }
    .customizer-toggle {
      display: none !important;
    }
  
    // Expense Specific Styles
    .invoice-preview-wrapper {
      .row.invoice-preview {
        .col-md-8 {
          max-width: 100%;
          flex-grow: 1;
        }
  
        .invoice-preview-card {
          .card-body:nth-of-type(2) {
            .row {
                > .col-12 {
                max-width: 50% !important;
              }
  
              .col-12:nth-child(2) {
                display: flex;
                align-items: flex-start;
                justify-content: flex-end;
                margin-top: 0 !important;
              }
            }
          }
        }
      }
  
      // Action Right Col
      .invoice-actions {
        display: none;
      }
    }
  }
  </style>
  